import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function Testimonials() {
  const navigate = useNavigate();
  const [testimonials, setTestimonials] = useState([]);
  const [confirmId, setConfirmId] = useState(null);

  /* 🔌 GET ALL TESTIMONIALS */
  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const res = await axios.get(
        "https://api.livestockify.com/api/admin/testimonials"
      );
      setTestimonials(res.data);
    } catch (err) {
      console.error("Failed to fetch testimonials", err);
    }
  };

  /*  DELETE TESTIMONIAL */
  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `https://api.livestockify.com/api/admin/testimonials/${id}`
      );

      setTestimonials((prev) => prev.filter((t) => t.id !== id));
      setConfirmId(null); // close popup
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-8 pl-14 md:pl-8">
        {/* HEADER */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-lg font-semibold text-green-700">
            Testimonials
          </h1>

          <button
            onClick={() => navigate("/uploads/testimonials/add")}
            className="border px-3 py-1.5 rounded-md text-sm"
          >
            + Add Testimonial
          </button>
        </div>

        {/* LIST */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <TestimonialCard
              key={t.id}
              testimonial={t}
              onEdit={() =>
                navigate(`/uploads/testimonials/edit/${t.id}`)
              }
              onDelete={() => setConfirmId(t.id)} 
            />
          ))}
        </div>
      </div>

      {/*  DELETE CONFIRMATION POPUP */}
      {confirmId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-xl w-full max-w-md p-6 shadow-lg">
            <h2 className="text-lg font-semibold text-gray-800 mb-3">
              Confirm Deletion
            </h2>

            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to delete this testimonials?
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setConfirmId(null)}
                className="border px-4 py-2 rounded-md text-sm"
              >
                Cancel
              </button>

              <button
                onClick={() => handleDelete(confirmId)}
                className="bg-red-600 text-white px-4 py-2 rounded-md text-sm"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* CARD COMPONENT */
function TestimonialCard({ testimonial, onEdit, onDelete }) {
  return (
    <div className="border rounded-xl p-4 shadow-sm max-w-[420px] bg-white">
      <div className="flex justify-between items-start">
        <div className="flex gap-3">
          <img
            src={testimonial.imageUrl}
            alt={testimonial.name}
            className="h-10 w-10 rounded-full object-cover"
          />
          <div>
            <p className="text-sm font-semibold text-green-700">
              {testimonial.name}
            </p>
            <p className="text-xs text-gray-500">
              {testimonial.position}
            </p>
          </div>
        </div>

        <div className="flex gap-3 text-xs">
          <button onClick={onEdit} className="text-green-600">
            Edit
          </button>
          <button onClick={onDelete} className="text-red-500">
            Delete
          </button>
        </div>
      </div>

      <p className="text-xs text-gray-600 mt-4 leading-relaxed">
        {testimonial.testimonial}
      </p>
    </div>
  );
}
